import styled from 'styled-components';

export const BiaTableContainer = styled.div`
  background: #FFFFFF;
  padding: 10px;
`;
